import { useState } from 'react'

import { UnifiedPerson } from 'CitizenProfile/types'
import { removeEverythingThatIsNotNumber } from 'utils/transforms/string'
import { validateCPF } from 'utils/validation/validators'
import getPersonInformationByCPF from './services/getPersonInformationByCPF'

export default function useGetPersonByCPF() {
  const [loadingCPF, setLoadingCPF] = useState<boolean>(false)
  const [person, setPerson] = useState<UnifiedPerson>({})

  async function getPersonByCPF(cpf: string): Promise<string> {
    const cpfOnlyNumber = removeEverythingThatIsNotNumber(cpf)
    const isCPFValid = validateCPF(cpf)
    if (isCPFValid) {
      setLoadingCPF(true)
      const response = await getPersonInformationByCPF({ cpf: cpfOnlyNumber })
      const isCPfCorrect = response?.header?.success
      if (isCPfCorrect) {
        const personFromAPI = response?.body?.person
        setPerson(personFromAPI)
      } else {
        setPerson({})
      }
      setLoadingCPF(false)
      return ''
    }
    setPerson({})
    return 'CPF inválido'
  }

  return { loadingCPF, person, setPerson, getPersonByCPF }
}
